import React, { useState } from 'react';
import { HelpCircle } from 'lucide-react';
import './Tooltip.css';

/**
 * Tooltip component for displaying detailed field descriptions
 * @param {string} content - Tooltip content text
 * @param {string} className - Additional CSS classes
 */
const Tooltip = ({ content, className = '' }) => {
    const [isVisible, setIsVisible] = useState(false);

    return (
        <div className={`tooltip-wrapper ${className}`}>
            <button
                type="button"
                className="tooltip-trigger"
                onMouseEnter={() => setIsVisible(true)}
                onMouseLeave={() => setIsVisible(false)}
                onFocus={() => setIsVisible(true)}
                onBlur={() => setIsVisible(false)}
                aria-label="Show help"
            >
                <HelpCircle size={18} />
            </button>
            {isVisible && (
                <div className="tooltip-content">
                    {content}
                </div>
            )}
        </div>
    );
};

export default Tooltip;
